import { graphql } from "./generated/index.js"

// Queries ======================================================================

/** The Email Thread documents that hold these Gmail threads, each with the
 *  records it is related to. */
export const fetchThreadLinks = graphql(`
  query fetchThreadLinks($threadIds: [String!]!) {
    record_sources(
      where: {
        source_type: { _eq: "gmail_thread" }
        source_id: { _in: $threadIds }
        record: { archived_at: { _is_null: true } }
      }
    ) {
      source_id
      record {
        id
        type
        name
        slug
        visibility
        schema_id
        children_aggregate {
          aggregate {
            count
          }
        }
        links(where: { schema_key: { _eq: "related_to" } }) {
          linked {
            id
            type
            name
            slug
            data
          }
        }
      }
    }
  }
`)

/** The open deals whose `person` link is one of these people, each with which. */
export const fetchOpenDealsForPeople = graphql(`
  query fetchOpenDealsForPeople($personIds: [Int!]!) {
    records(
      where: {
        type: { _eq: "deal" }
        archived_at: { _is_null: true }
        data: { _contains: { status: "open" } }
        links: { schema_key: { _eq: "person" }, linked_id: { _in: $personIds } }
      }
    ) {
      id
      type
      name
      slug
      data
      links(where: { schema_key: { _eq: "person" }, linked_id: { _in: $personIds } }) {
        linked_id
      }
    }
  }
`)

/** The Gmail message ids a saved thread's Email documents already hold. */
export const fetchThreadMessageSources = graphql(`
  query fetchThreadMessageSources($threadRecordId: Int!) {
    records(where: { parent_id: { _eq: $threadRecordId } }) {
      id
      data
      sources(where: { source_type: { _eq: "gmail_message" } }) {
        source_id
      }
    }
  }
`)
